var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeroCurve = function SvgHeroCurve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 100,
    viewBox: "0 0 1440 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.61554V100H1440V0.61554C1440 0.61554 1126 69 720 69C314 69 0 0.61554 0 0.61554Z",
    fill: "white"
  })));
};
export default SvgHeroCurve;